export default [{
  path: '/view/relatorio/:id/:externa',
  name: 'relatorioproposta',
  component: () => import('@/shared/components/relatorio-proposta/RelatorioProposta.vue'),
  meta: {
    requiredAuth: false,
    action: 'auditar',
    layout: 'full',
  },
}]
